import { ApiAIBillingType } from "@incendium/api";
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Loading from "Components/Loading/Loading";
import SpacedList from "Components/UI/SpacedList";
import { camelToText } from "Helpers/camelToText";
import { friendlyDateTime } from "Helpers/dates";
import { useMemo } from "react";
import useAIBillings from "features/ai/hooks/useAIBillings";
import useAIPromptBillings from "features/ai/hooks/useAIPromptBillings";
import { sortByDate } from "Helpers/arrays";

function formatBillingType(t: ApiAIBillingType | string | undefined): string {
  if (!t) return "—";
  return camelToText(String(t).replace(/^AIBillingType/, ""));
}

function AICreditsHistoryPage() {
  const { prompts, loading: promptsLoading } = useAIPromptBillings();
  const { billings, loading: billingsLoading } = useAIBillings();

  const loading = promptsLoading || billingsLoading;

  const billingMap = useMemo(() => {
    const map = new Map<ApiAIBillingType, string>();
    (billings ?? []).forEach((b) => {
      if (b.type) {
        map.set(b.type, b.name ?? formatBillingType(b.type));
      }
    });
    return map;
  }, [billings]);

  const sorted = useMemo(
    () => sortByDate([...(prompts ?? [])], "createdAt", false),
    [prompts]
  );

  if (loading) {
    return <Loading fullHeight />;
  }
  

  return (
    <SpacedList title="AI Credits History">
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Billing Type</TableCell>
          <TableCell>Cost (credits)</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sorted.length === 0 ? (
          <TableRow>
            <TableCell colSpan={3} align="center">
              No AI credits usage found
            </TableCell>
          </TableRow>
        ) : (
          sorted.map((prompt) => (
            <TableRow key={prompt.id}>
              <TableCell>
                {prompt.createdAt
                  ? friendlyDateTime(prompt.createdAt)
                  : "—"}
              </TableCell>
              <TableCell>
                {prompt.billingType
                  ? billingMap.get(prompt.billingType) ||
                    formatBillingType(prompt.billingType)
                  : "—"}
              </TableCell>
              <TableCell>
                {prompt.billingCost != null ? prompt.billingCost : "—"}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </SpacedList>
  );
}

export default AICreditsHistoryPage;
